<script>
	import Helper from '../../Classes/Helper';
	import Preference from '../../Stores/Preference';
	import Product from '../../Stores/Product';
	import Widget from '../../Stores/Widget';
	import {onMount} from 'svelte';

	export let config;
	let select = {};
	let input = {};
	let element = {};

	function getSelected() {
		let count = config.count ? parseInt(input.value) : +!config.checked;
		let value = config.options ? select.value : config.id;
		if (config.options) {
			const numeric = Number(value);
			if (!isNaN(numeric)) value = numeric;
			if (value) count = 1;
		}

		const valid = !!count;
		const state = valid ? 'success' : 'error';
		const price = config.price * count;
		const selection = config.options ? select.options[select.selectedIndex].text : '';
		const meta = config.options ? config.options[select.selectedIndex] : {};
		const label = config.count ? `${count}x ${config.title}` : config.title;
		const selected = {count, valid, state, price, value, selection, meta, label, id: config.id};
		return selected;
	}

	async function onClick(event) {
		Helper.stop(event);
		const source = event.target.nodeName.toLowerCase();
		const exclude = ['input', 'select'];
		if (!exclude.includes(source))
			if (config.on_click) {
				if (config.count) {
					const count = parseInt(input.value);
					if (!count) input.value = 1;
					else if (count === 1) input.value = 0;
				}

				const selected = getSelected();
				config.on_click(selected);
				await Preference.setValue(selected);
			}
	}

	async function onInput(event) {
		Helper.stop(event);
		if (config.on_input) {
			const selected = getSelected();
			config.on_input(selected);
			await Preference.setValue(selected);
		}
	}

	async function onChange(event) {
		Helper.stop(event);
		if (config.on_change) {
			const selected = getSelected();
			config.on_change(selected);
			await Preference.setValue(selected);
		}
	}

	function onStopPropagation(event) {
		Helper.stop(event);
	}

	async function preference() {
		if (!config.checked) {
			const preference = await Preference.getValue();
			if (preference.label === config.title) {
				if (Helper.is(input) && (input.value != preference.count)) {
					input.value = preference.count;
					const event = new window.Event('change');
					input.dispatchEvent(event);
				}
				else if (Helper.is(element) && preference.valid) {
					const event = new window.Event('click');
					element.dispatchEvent(event);
				}
			}
		}
	}

	async function mount() {
		await preference();
	}

	$: if (config.active) $Widget.current = element;
	onMount(mount);
</script>

<style>
	div.zes-option {
		display: grid;
		grid-template-columns: auto;
		gap: 1em;
		padding: 1em;
		margin-bottom: 1.5em;
		border: 1px solid transparent;
		border-radius: .5em;
		background: hsl(0deg 0% 44% / .1);
		cursor: pointer;
	}

	div.zes-option.zes-option-image {
		grid-template-columns: auto 1fr;
	}

	div.zes-option:hover {
		border-color: var(--zes-1-3);
	}

	div.zes-option.zes-active {
		border: 1px solid var(--zes-1-3);
		box-shadow: 0 0 .5em 0 var(--zes-1-3);
		background: var(--zes-1-4);
	}

	div.zes-option-media {
		width: 8em;
		height: 8em;
		background: transparent no-repeat center;
		background-size: cover;
		border-radius: .5em;
	}

	div.zes-compact div.zes-option-media {
		width: 5em;
		height: 5em;
	}

	div.zes-option-content {
		flex-grow: 1;
	}

	div.zes-option-header {
		display: flex;
		gap: 1em;
	}

	div.zes-option-header-count input {
		font: inherit;
		font-weight: 600;
		text-align: center;
		color: var(--zes-1-1);
		background: hsl(0deg 100% 100%);
		padding: .25em .5em;
		border: 1px solid hsl(206deg 75% 25% / .25);
		border-radius: .35em;
		width: 2em;
	}

	div.zes-option-header-icon i {
		font-size: 1.5em;
		padding: .25em .15em 0 .15em;
		color: var(--zes-1-2);
	}

	div.zes-option-header-icon.zes-success i {
		color: var(--zes-1-3);
	}

	div.zes-option-header-title {
		font-size: 1.25em;
		font-weight: 600;
		color: var(--zes-1-1);
		padding-top: .1em;
		flex-grow: 1;
	}

	div.zes-option-header-title span {
		font-size: .55em;
		font-weight: 600;
		text-transform: uppercase;
		color: #FFF;
		padding: .25em 1em;
		margin: .5em 0 0 1em;
    	vertical-align: middle;
		background: var(--zes-1-2);
		border-radius: .5em;
		display: inline-block;
		box-shadow: 0 0 .75em 0 var(--zes-1-3);
		position: absolute;
	}

	div.zes-option-header-price {
		font-size: 1.25em;
		font-weight: 600;
		letter-spacing: -.025em;
		color: var(--zes-1-2);
		padding-top: .1em;
	}

	div.zes-option-header-price div {
		font-size: .7em;
		color: var(--zes-3-2);
		margin-right: .5em;
		display: inline-block
	}

	div.zes-option-header-price span {
		color: var(--zes-2-2);
		display: inline-block
	}

	div.zes-option-select {
		font-size: .8em;
		margin: .75em 0 .4em 3.75em;
	}

	div.zes-option-select select {
		font: inherit;
		font-weight: 600;
		color: var(--zes-1-1);
		background: #FFF;
		padding: .5em;
		border: 1px solid #FFF;
		border-radius: .35em;
		display: block;
		width: 100%;
	}

	div.zes-option-description {
		font-size: .8em;
		color: var(--zes-3-1);
		padding-top: 1em;
		margin-left: 3.75em;
		overflow: auto;
		max-height: 9em;
	}

	div.zes-compact div.zes-option-description {
		padding-top: .5em;
	}

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-option.zes-option-image {
			grid-template-columns: 1fr;
		}

		div.zes-option-media {
			width: auto;
			height: 10em;
			background-color: #FFF;
			background-size: contain;
		}

		div.zes-option-header-title span {
			display: none;
		}

		div.zes-option-header-price {
			text-align: right;
		}
	}
</style>

<div bind:this="{element}" on:click|stopPropagation="{event => onClick(event)}" class="zes-option" class:zes-option-image="{config.image}" class:zes-active="{config.active || config.checked}" class:zes-compact="{config.compact}">
	{#if config.image}
		<div class="zes-option-media" style="background-image: url('{Helper.image(config.image)}')"></div>
	{/if}
	<div class="zes-option-content">
		<div class="zes-option-header">
			{#if config.count}
				<div class="zes-option-header-count">
					<input bind:this="{input}" on:change|stopPropagation="{event => onInput(event)}" on:click|stopPropagation="{event => onStopPropagation(event)}" value="{config.value}" type="text" inputmode="numeric" pattern="[0-9]*"/>
				</div>
			{:else if config.checked}
				<div class="zes-option-header-icon zes-success">
					<i class="fa-regular fa-circle-check"></i>
				</div>
			{:else}
				<div class="zes-option-header-icon">
					<i class="fa-regular fa-circle"></i>
				</div>
			{/if}
			<div class="zes-option-header-title">
				{config.title}
				{#if config.badge}
					<span>{config.badge}</span>
				{/if}
			</div>
			{#if config.price}
				<div class="zes-option-header-price">
					{#if config.price_high}
						<div class="zes-strike">{Product.price(config.price_high)}</div>
					{/if}
					<span>{Product.price(config.price)}</span>
				</div>
			{/if}
		</div>
		{#if config.options}
			<div class="zes-option-select">
				<select bind:this="{select}" on:change|stopPropagation="{event => onChange(event)}">
					{#each config.options as option}
						<option value="{option.value}" selected="{(option.value === config.value) || null}">{option.label || option.value}</option>
					{/each}
				</select>
			</div>
		{/if}
		{#if config.description}
			<div class="zes-option-description">{@html config.description}</div>
		{/if}
	</div>
</div>